module.exports = __webpack_public_path__ + "static/media/AX.1434b6ff.svg";